export const environment = {
    production: false,
    apiUrl: "https://api.syrzdarma.staging.vps2.ahron.cz/",
    cdnUrl: "https://cdn.syrzdarma.staging.vps2.ahron.cz/file/",
    distFolder: "browser",
    forceDomain: false,
    cacheApiRequests: false,
    debug: true,
};
